import { render, staticRenderFns } from "./WeComAuth.vue?vue&type=template&id=0222ab14&"
import script from "./WeComAuth.vue?vue&type=script&lang=js&"
export * from "./WeComAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports